import cn from "classnames";
import { TPerformanceRatingSummaryKey } from "@/pages/(admin)/performance-review/helper";
import { getRatingColor } from "../constants";

export interface ITeamMember {
  fmno: string;
  full_name: string;
  bucket?: TPerformanceRatingSummaryKey;
  overall_rating?: string;
}

interface TeamMemberSelectorProps {
  teamMembers: ITeamMember[];
  selectedMember?: ITeamMember;
  onSelectMember: (member: ITeamMember) => void;
}

export const TeamMemberSelector = (props: TeamMemberSelectorProps) => {
  const { teamMembers, selectedMember, onSelectMember } = props;

  return (
    <div className="flex flex-wrap gap-2">
      {teamMembers.map((member) => (
        <button
          key={member.fmno}
          type="button"
          onClick={() => onSelectMember(member)}
          aria-label={`Select team member ${member.full_name}`}
          aria-pressed={selectedMember?.fmno === member.fmno}
          className={cn(
            "cursor-pointer rounded-lg p-3 text-sm font-bold transition-colors",
            selectedMember?.fmno === member.fmno
              ? "bg-[#5A5A5A] text-[#F3F3F3]"
              : `bg-[#F5F5F5] hover:bg-gray-300 ${getRatingColor(member.bucket)}`,
          )}
        >
          {member.full_name}
        </button>
      ))}
    </div>
  );
};
